export class SocialLoginModel {
    public token: string;
  }
  